import { EPromoType } from '../../repositories/newbuilding-promos/entities/promo_search_result/PromoSearchItemSchema';
import { TProductsById } from '../../types/analytics';
import { EProductType, IProduct } from '../../types/product';
import { TSearchPromosResponse } from '../../types/searchResponse';

const PRODUCT_TYPE_MAP = new Map<EPromoType, EProductType>([
  [EPromoType.Bonus, EProductType.Bonus],
  [EPromoType.CianMortgage, EProductType.CianMortgage],
  [EPromoType.Discount, EProductType.Discount],
  [EPromoType.MaternalCapital, EProductType.MaternalCapital],
  [EPromoType.Military, EProductType.MilitaryMortgage],
  [EPromoType.Mortgage, EProductType.Mortgage],
]);

export const mapProducts = (promosResponse: TSearchPromosResponse, positionOffset: number = 0) => {
  const productsById: TProductsById = {};
  const products: IProduct[] = [];

  promosResponse.promoSearchResult.promos.forEach((promo, idx) => {
    const product: IProduct = {
      // @ts-expect-error Убрать директиву в CD-203170
      id: promo.providerPromoId,
      position: idx + positionOffset + 1,
      offerType: 'promo',
      extra: {
        type: PRODUCT_TYPE_MAP.get(promo.promoType) as EProductType,
        name: promo.promoName,
        uniquePromoId: promo.uniquePromoId,
      },
    };

    productsById[promo.uniquePromoId] = product;
    products.push(product);
  });

  return { products, productsById };
};
